"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLoader = exports.Loader = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Wrapper = (0, styled_components_1.default)('div') `
  height: ${({ $scSize }) => `${$scSize}px`};
  width: ${({ $scSize }) => `${$scSize}px`};
`;
const Inner = (0, styled_components_1.default)('div') `
  height: 100%;
  width: 100%;
  animation: rotate 1s infinite linear;
  border: ${({ theme, $scSize, $scColor }) => `${$scSize / 6.5}px solid ${$scColor !== null ? $scColor : theme.color.primary}`};
  border-right-color: transparent;
  border-radius: 50%;

  @keyframes rotate {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;
const ContentWrapper = (0, styled_components_1.default)('div') `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Loader = ({ size = 'm', color = null, className = '', }) => {
    const sizeMapping = {
        m: 16,
        l: 24,
        xl: 40,
        xxl: 110,
    };
    const sizeName = size in sizeMapping
        ? sizeMapping[size]
        : 16;
    return (React.createElement(Wrapper, { className: className, "$scSize": sizeName, "data-testid": "Loader" },
        React.createElement(Inner, { "$scSize": sizeName, "$scColor": color })));
};
exports.Loader = Loader;
const ContentLoader = (_a) => {
    var { className } = _a, restProps = __rest(_a, ["className"]);
    return (React.createElement(ContentWrapper, { className: className },
        React.createElement(exports.Loader, Object.assign({}, restProps))));
};
exports.ContentLoader = ContentLoader;
exports.default = exports.Loader;
